import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
const store = new Vuex.Store({
  state: {
    cartProducts: [],
    purchasingProduct: "",
    user: "",
    owners: "",
    apartment: "",
    fromBuyNow: false,
    allProduct: "",
    hashBalanceProduct: [],
    carts:"",
    noNav: false,
    purchasingType:""
  },
  mutations: {
    setPurchasingProduct(state,playload){
      state.purchasingProduct = playload
    },
    setCartProducts(state,playload){
      state.cartProducts = playload
    },
    setCarts(state,playload){
      state.carts = playload
    },
    cartToPurchasing(state,playload){
      state.purchasingProduct = playload
    },
    setUser(state,playload){
      state.user = playload
    },
    setOwners(state,playload){
      state.owners = playload
    },
    setApartment(state,playload){
      state.apartment = playload
    },
    setFromBuyNow(state,playload){
      state.fromBuyNow = playload
    },
    setAllProduct(state,playload){
      state.allProduct = playload
    },
    setHashBalanceProduct(state,playload){
      state.hashBalanceProduct = playload
    },
    addHashBalanceProduct(state,playload){
      state.hashBalanceProduct[playload.productId] = playload
    },
    setNoNav(state , playload){
      state.noNav = playload
    },
    setPurchasingType(state , playload){
      console.log(playload)
      state.purchasingType = playload
    },
  }
})
export default store